;(function () {
    window.addEventListener('load', () => {
        Fancybox.bind('[data-fancybox]', {
            // Your custom options
        })
    })
})()
